module.exports = __webpack_public_path__ + "images/line_silver_e921450218cb3e5fd268f648b0dc95ef.jpg";